import React, { useContext, useState, useEffect } from "react";
import styles from "./PerdidaSesion.module.css";
import alertaImg from '../../img/alerta.png';
import AuthService from '../../utils/auth/Auth.service';
import GeneralContext from "../../context/GeneralContext";
import * as GeneralActions from "../../store/actions/generalActions";
import * as GeneralRepository from "../../services/repositories/general-repository";
import * as Constantes from "../../utils/constantes";

const PerdidaSesion = () => {
    const { state: generalState, dispatch: generalDispatch } = useContext(GeneralContext)
    let users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null
    let user = users !== null ? users.filter(user => user.isAuthenticated)[0] : null
    const [ mostrar, setMostrar ] = useState(false)
    
    const authService = new AuthService()

    useEffect(() => {
        if(generalState.tiempoSesion !== null && user !== undefined) {
            let interval = setInterval(() => {
                let dato = Constantes.TIEMPO_RENOVAR_SESION * 60
                if(generalState.tiempoSesion > 0 && generalState.tiempoSesion <= dato) {
                    setMostrar(true)
                    generalDispatch(GeneralActions.updateTiempoSesion(generalState.tiempoSesion - 1))
                } else if(generalState.tiempoSesion === 0) {
                    setMostrar(false)
                    clearInterval(interval)
                    cerrarSesion()
                } else {
                    setMostrar(false)
                    clearInterval(interval)
                    generalDispatch(GeneralActions.updateTiempoSesion(generalState.tiempoSesion - 1))
                }
            }, 1000)
            return () => {
                clearInterval(interval)
            }
        }
    }, [ user, generalState.tiempoSesion ])

    const renovarSesion = () => {
        GeneralRepository.renovarToken()
        generalDispatch(GeneralActions.updateTiempoSesion(Constantes.TIEMPO_SESION * 60))
    }

    const cerrarSesion = () => {
        generalDispatch(GeneralActions.logout())
        authService.logout()
        window.location.href = '/login'
    }

    return (
        <React.Fragment>
            {mostrar === true
                ? <div className={styles.contenedor}>
                    <div className={styles.titulo}>
                        <img src={alertaImg} className={styles.imagen} alt='' />
                    </div>
                    <div className={styles.mensaje}>
                        <div>
                            <label className={styles.mensaje_strong}>¡Advertencia!</label>
                            <br />
                            <label>
                                La sesión está a punto de expirar.
                                Tienes {generalState.tiempoSesion} segundos para renovar la sesión.
                                <br />
                                <div className={styles.link} onClick={() => renovarSesion()}>Haz click aquí</div>.
                            </label>
                            <br />
                        </div>
                    </div>
                </div>
                : null
            }
        </React.Fragment>
    )
}

export default PerdidaSesion;